// removed by extract-text-webpack-plugin
module.exports = {"help-resources":"HelpDeskInfo__help-resources___1Y9fe","section":"HelpDeskInfo__section___7v0TJ"};